import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import Services from "./components/Services";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import StructuredData from "./components/StructuredData";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Ochoa Herrera & Asociados | Despacho Jurídico en Cuernavaca</title>
        <meta name="description" content="Despacho jurídico en Cuernavaca con más de 11 años de experiencia. Asesoría legal con enfoque humanista en Derecho Civil, Penal, Familiar, Laboral y más. Contacto: 777 149 5537" />
        <meta name="keywords" content="abogados cuernavaca, despacho jurídico morelos, asesoría legal cuernavaca, derecho civil, derecho penal, derecho familiar, abogados morelos, ochoa herrera, plaza arcángel" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ochoaherrerayasociados.com" />
        <meta property="og:title" content="Ochoa Herrera & Asociados | Despacho Jurídico en Cuernavaca" />
        <meta property="og:description" content="Más de 11 años brindando asesoría legal con calidez humana en Cuernavaca. Contáctanos: 777 149 5537" />
        <meta property="og:image" content="https://customer-assets.emergentagent.com/job_661426c8-676a-4387-8d77-4e9e1aa6a517/artifacts/1a2m54ip_Logo%20OH%20%26%20Asociados.png" />
        <meta property="og:locale" content="es_MX" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://ochoaherrerayasociados.com" />
        <meta name="twitter:title" content="Ochoa Herrera & Asociados | Despacho Jurídico en Cuernavaca" />
        <meta name="twitter:description" content="Asesoría legal con enfoque humanista en Cuernavaca, Morelos. Más de 11 años de experiencia." />
        <meta name="twitter:image" content="https://customer-assets.emergentagent.com/job_661426c8-676a-4387-8d77-4e9e1aa6a517/artifacts/1a2m54ip_Logo%20OH%20%26%20Asociados.png" />
        
        {/* Additional SEO */}
        <meta name="author" content="Ochoa Herrera & Asociados" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="Spanish" />
        <meta name="geo.region" content="MX-MOR" />
        <meta name="geo.placename" content="Cuernavaca" />
        <meta name="contact" content="contacto@ochoaherrerayasociados.com" />
        <link rel="canonical" href="https://ochoaherrerayasociados.com" />
      </Helmet>
      
      <StructuredData />
      
      <Header />
      <main>
        <div id="hero">
          <Hero />
        </div>
        <Intro />
        <Services />
        <About />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
